/**
 * Store admin — reports route (Commerce, V1.0.1).
 *
 * Skeleton until the module is built; see `STORE_MODULES["reports"]` for its
 * milestone and planned screens. @see docs/ecom/v1.0.1-tasks.md
 */
import { createFileRoute } from "@tanstack/react-router";
import {
  StoreModulePlaceholder,
  STORE_MODULES,
} from "../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/reports/")({
  component: () => <StoreModulePlaceholder {...STORE_MODULES["reports"]} />,
});
